import { Link, useLocation } from "react-router-dom";
import "../../App.scss"
import Nav from "../nav/nav";
import { useEffect, useRef, useState } from "react";
import close from "./close.png"
import da from "./da.png"
import search from "./search.png"
import categories from "../shop/categories.json"
import testimonials from "./testimonials.json"


function Home() {

    const location = useLocation();
    const [searchValue, setsearchValue] = useState("")
    const isActive = (path) => location.pathname === path;
    const [showSearch, setShowSearch] = useState(false)

    useEffect(() => {
        if (searchValue.length > 0) {
            setShowSearch(true)
        }
    })

    const [catValue, setCatValue] = useState("All Categories")

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const openCats = () => {
        if (isOpen) {
            setIsOpen(false)
        }
        else {
            setIsOpen(true)
        }
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <div className="Home">
            <div className="home-box">

                <div className="main-box">
                    {
                        isActive("/") ? <Nav /> : null
                    }
                    <div className="welcome-box">

                        <div className="welcome-div">
                            <p className="sub-tagline" >
                                Tailored solutions for every paw
                            </p>
                            <p className="tagline">
                                Your one-stop destination for all canine things!
                            </p>
                        </div>
                        <div className="input-div">
                            <div className="input-box"> 
                                <div class="dropdown" ref={dropdownRef}>
                                    <div onClick={openCats} className="drpbox">
                                        <p class="dropbtn">{catValue}</p>
                                        <img className={isOpen ? "da daOpen" : "da"} src={da} />
                                    </div>
                                    {isOpen && (
                                        <div className="dropdown-content">
                                            {categories.map((ct, index) => (
                                                <p href="#" onClick={() => { setCatValue(ct); setIsOpen(false) }} key={index}>{ct}</p>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className="search-field-box">
                                    <input value={searchValue} onChange={(e) => { setsearchValue(e.target.value) }} className="search-field" placeholder={"Search in " + catValue} />
                                    {
                                        searchValue.length > 0
                                            ? <img className="close" onClick={() => (setsearchValue(''))} src={close} />
                                            : <p className="nullPara" ></p>
                                    }
                                    {
                                        searchValue.length > 0
                                            ? <Link to={{
                                                pathname: "/shop",
                                                search: `?catValue=${encodeURIComponent(catValue)}&searchValue=${encodeURIComponent(searchValue)}`
                                            }}>
                                                <button className="search-button" >Search</button>
                                            </Link>

                                            : <button className="search-button disabled " >Search</button>
                                    }

                                </div>
                            </div>


                            <div className="suggestions-div">
                                <div className="suggestion">
                                    <img className="searchImg" src={search} />
                                    <Link to={{
                                        pathname: "/shop",
                                        search: `?catValue=${encodeURIComponent(catValue)}&searchValue=${encodeURIComponent("Dog Toys")}`
                                    }}>
                                        <p className="suggestion-text"  >Dog Toys</p>
                                    </Link>
                                </div>
                                <div className="suggestion">
                                    <img className="searchImg" src={search} />
                                    <Link to={{
                                        pathname: "/shop",
                                        search: `?catValue=${encodeURIComponent(catValue)}&searchValue=${encodeURIComponent("Puppy Treats")}`
                                    }}>
                                        <p className="suggestion-text"  >Puppy Treats</p>
                                    </Link>
                                </div>
                                <div className="suggestion">
                                    <img className="searchImg" src={search} />
                                    <Link to={{
                                        pathname: "/shop",
                                        search: `?catValue=${encodeURIComponent(catValue)}&searchValue=${encodeURIComponent("Dog Beds")}`
                                    }}>
                                        <p className="suggestion-text"  >Dog Beds</p>
                                    </Link>
                                </div>
                                <div className="suggestion">
                                    <img className="searchImg" src={search} />
                                    <Link to={{
                                        pathname: "/shop",
                                        search: `?catValue=${encodeURIComponent(catValue)}&searchValue=${encodeURIComponent("Medicines")}`
                                    }}>
                                        <p className="suggestion-text"  >Medicines</p>
                                    </Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="catHome-main-box pad10">
                    <center>
                        <p className="heading">Our popular categories</p>
                    </center>
                    <div className="home-category-box">

                        <Link to={{
                            pathname: "/shop",
                            search: `?catValue=${encodeURIComponent("Food & Nutrition")}&searchValue=${encodeURIComponent(searchValue)}`
                        }}>
                            <div className="catHomeOne">

                                <p className="catText" >Food & Nutrition</p>


                            </div>
                        </Link>

                        <Link to={{
                            pathname: "/shop",
                            search: `?catValue=${encodeURIComponent("Grooming Supplies")}&searchValue=${encodeURIComponent(searchValue)}`
                        }}>
                            <div className="catHomeTwo">

                                <p className="catText" >Grooming Supplies</p>

                            </div>
                        </Link>

                        <Link to={{
                            pathname: "/shop",
                            search: `?catValue=${encodeURIComponent("Dental Care")}&searchValue=${encodeURIComponent(searchValue)}`
                        }}>
                            <div className="catHomeThree">

                                <p className="catText" >Dental Care</p>

                            </div>
                        </Link>

                        <Link to={{
                            pathname: "/shop",
                            search: `?catValue=${encodeURIComponent("Medical Supplies")}&searchValue=${encodeURIComponent(searchValue)}`
                        }}>
                            <div className="catHomeFour">

                                <p className="catText" >Medical Supplies</p>

                            </div>
                        </Link>
                    </div>
                </div>

                {/* <div className="catHome-main-box ch pad10">
                    <center>
                        <p className="heading">Our popular guides</p>
                    </center>
                    <div className="home-category-box">
                       

                        <div className="guideHomeOne">
                            <p className="catText" >Basic Care </p>
                        </div>
                        <div className="guideHomeTwo">
                            <p className="catText" >Nutrition & Diet</p>
                        </div>
                        <div className="guideHomeThree">
                            <p className="catText" >Behavior & Training</p>
                        </div>
                        <div className="guideHomeFour">
                            <p className="catText" >Traveling with Dogs</p>
                        </div>
                    </div>
                </div> */}

                <div className="vision-main-box ch pad10">
                    <center>
                        <p className="heading">Our vision</p>
                    </center>
                    <p className="vision">
                        At Caninely, our vision is to become the premier destination for pet parents seeking to provide the best for their beloved dogs. We envision a holistic platform that not only offers a wide array of high-quality products but also serves as an educational hub, empowering pet owners with the knowledge and resources they need to raise happy, healthy, and well-rounded canine companions.
                    </p>
                </div>



                <div className="vision-main-box ch pad10">
                    <center>
                        <p className="heading">Our story</p>
                    </center>
                    <p className="vision">
                        Caninely was born from a deeply personal journey. As the founder, I experienced firsthand the challenges of pet parenthood when I welcomed a puppy into my life. Despite my enthusiasm and dedication, I soon realized that the resources available for pet parents were fragmented and insufficient. This realization sparked a passion to create a comprehensive solution that would fill the gap in the market and provide pet parents with the support they deserve.
                    </p>
                </div>

                <div className="vision-main-box ch pad10">
                    <center>
                        <p className="heading">Our mission</p>
                    </center>
                    <p className="vision">
                        At Caninely, our mission is twofold. Firstly, we are dedicated to curating a diverse range of products that cater to every aspect of a dog's life. From nutritious food and comfortable bedding to innovative toys and essential grooming and medical supplies, we meticulously select each item to ensure the well-being and happiness of our furry friends.

                        <br /><br />
                        Secondly, we are committed to empowering pet parents with the knowledge and skills they need to be confident caregivers. Through our extensive educational resources, including informative articles and step-by-step guides, we aim to cover every aspect of dog care, from basic obedience training and behavior management to advanced health and wellness tips.
                    </p>
                </div>


                {/* <div className="vision-main-box ch pad10">
                    <center>
                        <p className="heading">Our promise</p>
                    </center>
                    <p className="vision">
                        At Caninely, we understand that every dog is unique, and so are their needs. That's why we promise to provide personalized support and guidance to every pet parent who joins our community. Whether you're a novice dog owner navigating the challenges of puppyhood or an experienced enthusiast looking to enhance your dog's quality of life, we are here to offer expert advice, tailored recommendations, and unwavering support every step of the way.
                        <br /><br />
                        Join us at Caninely, where we don't just sell products — we foster a community of empowered pet parents who share a deep love and respect for their canine companions. Together, we celebrate the extraordinary bond between humans and dogs and strive to create a world where every dog receives the love, care, and attention they deserve.
                    </p>
                </div> */}

                <div className="newsletter-main ch pad10">
                    <div className="newsletter-box">

                        <p className=" heading newsHead ">Get updates of your canine's favourite things</p>
                        <div className="input-box-news">
                            <input className="news-input" placeholder="Enter email here" />
                            <button className="news-button" >SignUp</button>
                        </div>
                    </div>
                </div>

                {/* <div className="testimonials-main ch pad10">
                    <div className="testimonials-box">
                        {
                            testimonials.map((t) => (
                                <div className="testimonial">
                                    <p className="testiText">
                                        {t.feedback}
                                    </p>
                                    <p className="testiName" >
                                       by {t.name}
                                    </p>
                                </div>
                            ))
                        }
                    </div>
                </div> */}





            </div>
        </div>
    )
}

export default Home